(function () {
	angular
		.module('appback')
		.filter('tipobioq', tipobioq);

	tipobioq.$inject = ['$sce'];
	function tipobioq($sce) {
		return function (item, categoriaid) {
			/*console.log("item", item);
			console.log("categoriaid", categoriaid);*/

			if (!Array.isArray(item)) {
				return [];
			}
			var out = [];
			for (var i = 0; i < item.length; i++) {
				if (item[i].analiticas && Array.isArray(item[i].analiticas)) {
					for (var j = 0; j < item[i].analiticas.length; j++) {
						var categoriaListaId = item[i].analiticas[j].analitica.categorialista_id;
    
						// Convertir a array si no lo es
						if (!Array.isArray(categoriaListaId)) {
							categoriaListaId = [categoriaListaId];
						}

						if (categoriaListaId.includes(categoriaid)) {
							out.push(item[i]);
							break;
						}
						
					}
				}
			}
			return out;

		};
	}
})();